export default __webpack_public_path__ + "static/media/kiril-z.313bce39.png";